//在此处编写调用授权等基本平台接口
import store from '@/store/'
class oe_api {
	constructor(axiosFactory) {
		this.$http = axiosFactory;
	}
	http() {
		return this.$http;
	};
	  get(url, cb) {
		this.$http.get(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});;
	}
	gets(url, data, cb) {
		this.$http.get(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	post(url, data, cb) {
		this.$http.post(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	posts(url, cb) {
		this.$http.post(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	put(url, data, cb) {
		this.$http.put(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	puts(url, cb) {
		this.$http.put(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	delete(url, data, cb) {
		this.$http.delete(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	deletes(url, cb) {
		this.$http.delete(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}

	//------------------------------------------------------------
    //获取公司企业信息
    // async getEnterpriseInfomation(){
    //   return await this.$oe.get(`/get/enterpriseInformation`).then(res=>{
    //     if (res.status =='200'){
    //       return res.data;
    //     }
    //   });
    // }

    //求职者端企业信息
    getJobHunterConpanyInformation(userName, cb) {
      this.get(`/${userName}/enterprise/information`,cb);
    }

    //获取公司地址
    // async getEnterpriseLocation(){
    //   return await this.$oe.get(`/get/enterpriseLocation`).then(res=>{
    //     if (res.status=='200'){
    //       return res.data;
    //     }
    //   });
    // }
    getEnterpriseLocation(userName, cb) {
      this.get(`/${userName}/enterprise/location`,cb);
    }
    getMyEnterpriseCertifications(chainName,cb){
      this.get(`/enterprise/${chainName}/certifications`,cb);
  }}


  class apiFactory {
    constructor() {

    }
    createApi(axios) {
        return new oe_api(axios)
    }
  }
  export default new apiFactory();

